import { Component } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { setActivePath } from '../../../state/app/app.actions';
import { AuthenticationService } from '../../../services/authentication.service';
import { selectIsAuthenticated } from '../../../state/auth/auth.selectors';

@Component({
  selector: 'nav-bar',

  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss',
})
export class NavBarComponent {
  activePath$: Observable<string>;
  currentPath: string;
  isAuthenticated$!: Observable<boolean>;

  navLinks = [
    { label: 'Providers', path: '/providers' },
    { label: 'Professionals', path: '/professionals' },
    { label: 'Disciplines', path: '/disciplines' },
  ];

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private store: Store
  ) {}

  ngOnInit() {
    this.isAuthenticated$ = this.store.select(selectIsAuthenticated);

    this.activePath$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.router.url.split('?')[0])
    );

    this.activePath$.subscribe((currentPath) => {
      this.currentPath = currentPath;
      this.store.dispatch(setActivePath({ activePath: currentPath }));
    });
  }

  navigate(path: string) {
    this.router.navigate([path]);
  }

  onLogout() {
    this.authenticationService.redirectToHome();
  }
}
